/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Tree, TreeNode } from 'react-organizational-chart';
import { getOrgHierarchy } from '../../../services/clientAdmin/departmentServices';

function NodeCard({ title, subtitle, email, color = 'border-gray-300', bg = 'bg-white' }) {
  return (
    <div className={`inline-block ${bg} border-2 ${color} rounded-xl px-4 py-2.5 shadow-sm text-center min-w-[140px]`}>
      <p className="text-sm font-semibold text-gray-900">{title}</p>
      {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
      {email && <p className="text-xs text-gray-400 mt-0.5 truncate max-w-[160px]">{email}</p>}
    </div>
  );
}

export default function OrgHierarchy() {
  const { userInfo } = useSelector((state) => state);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getOrgHierarchy().then(r => {
      if (r.ok) setDepartments(r.data || []);
    }).finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="p-4">
      <div className="h-6 w-48 bg-gray-200 rounded animate-pulse mb-6" />
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-40 bg-gray-100 rounded-xl animate-pulse" />
        <div className="flex gap-8">{[1,2,3].map(i => <div key={i} className="h-12 w-36 bg-gray-100 rounded-xl animate-pulse" />)}</div>
      </div>
    </div>
  );

  const orgName = userInfo?.organizationName || userInfo?.name || 'Organisation';

  return (
    <div className="p-4 overflow-x-auto">
      <h3 className="text-lg font-semibold text-gray-900 mb-6">Organisation Hierarchy</h3>

      {departments.length === 0 ? (
        <p className="text-sm text-gray-400 text-center py-8">No departments created yet.</p>
      ) : (
        <Tree
          lineWidth="2px"
          lineColor="#cbd5e1"
          lineBorderRadius="6px"
          label={<NodeCard title={orgName} subtitle="Organisation" color="border-purple-500" bg="bg-purple-50" />}
        >
          {departments.map(dept => (
            <TreeNode key={dept.id} label={
              <NodeCard title={dept.name} subtitle={dept.headName} email={dept.headEmail} color="border-blue-400" bg="bg-blue-50" />
            }>
              {dept.teams.map(team => (
                <TreeNode key={team.id} label={
                  <NodeCard title={team.name} subtitle={team.leaderName} email={team.leaderEmail} color="border-green-400" bg="bg-green-50" />
                } />
              ))}
            </TreeNode>
          ))}
        </Tree>
      )}
    </div>
  );
}
